<template>
  <div class="gateway-register">
    <div class="gateway-register__stage">
      <aside class="gateway-register__brand" aria-label="Brand">
        <div class="gateway-register__atmosphere" aria-hidden="true">
          <div class="gateway-register__orb gateway-register__orb--a"></div>
          <div class="gateway-register__orb gateway-register__orb--b"></div>
          <div class="gateway-register__grid"></div>
          <svg
            class="gateway-register__signal"
            viewBox="0 0 420 320"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              class="gateway-register__path"
              d="M40 220 C110 120, 180 280, 250 160 S380 80, 400 140"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-dasharray="6 8"
            />
            <circle class="gateway-register__node" cx="40" cy="220" r="6" />
            <circle
              class="gateway-register__node gateway-register__node--delay"
              cx="250"
              cy="160"
              r="6"
            />
            <circle
              class="gateway-register__node gateway-register__node--delay-2"
              cx="400"
              cy="140"
              r="6"
            />
            <rect
              x="286"
              y="48"
              width="108"
              height="52"
              rx="14"
              class="gateway-register__bubble"
            />
            <rect
              x="48"
              y="248"
              width="132"
              height="44"
              rx="14"
              class="gateway-register__bubble gateway-register__bubble--soft"
            />
          </svg>
        </div>

        <router-link to="/home" class="gateway-register__home">
          ← Beranda
        </router-link>

        <div class="gateway-register__brand-copy">
          <p class="gateway-register__eyebrow">WhatsApp Gateway Service</p>
          <h1 class="gateway-register__name">
            {{ info.app_name || "SenderWA" }}
          </h1>
          <p class="gateway-register__tagline">
            Buat akun dan mulai kirim notifikasi, OTP, serta broadcast WhatsApp
            dari satu dashboard.
          </p>
          <ul class="gateway-register__points">
            <li>Multi nomor &amp; API key</li>
            <li>Jadwal kirim &amp; auto reply</li>
            <li>Inbox &amp; status terkirim</li>
          </ul>
        </div>

        <p class="gateway-register__footnote">
          © {{ year }} {{ info.app_company || "SenderWA" }}
        </p>
      </aside>

      <section class="gateway-register__panel">
        <div class="gateway-register__form-wrap">
          <header class="gateway-register__form-head">
            <h2 class="gateway-register__form-title">Buat akun baru</h2>
            <p class="gateway-register__form-desc">
              Isi data di bawah untuk mendaftar layanan gateway. Setelah
              berhasil, Anda bisa masuk dan menghubungkan nomor WhatsApp.
            </p>
          </header>

          <form class="gateway-register__form" @submit.prevent="postRegister">
            <div class="gateway-register__field">
              <label class="gateway-register__label" for="reg-name">
                Nama lengkap
              </label>
              <input
                id="reg-name"
                v-model.trim="name"
                class="gateway-register__input"
                type="text"
                name="name"
                autocomplete="name"
                placeholder="Nama sesuai identitas"
                :disabled="submitting"
              />
            </div>

            <div class="gateway-register__field">
              <label class="gateway-register__label" for="reg-email">
                Email
              </label>
              <input
                id="reg-email"
                v-model.trim="email"
                class="gateway-register__input"
                type="email"
                name="email"
                autocomplete="email"
                placeholder="nama@perusahaan.com"
                :disabled="submitting"
              />
            </div>

            <div class="gateway-register__field">
              <label class="gateway-register__label" for="reg-phone">
                Nomor WhatsApp
              </label>
              <input
                id="reg-phone"
                v-model.trim="phone"
                class="gateway-register__input"
                type="tel"
                name="phone"
                autocomplete="tel"
                placeholder="62812xxxxxxxx"
                :disabled="submitting"
              />
            </div>

            <div class="gateway-register__row">
              <div class="gateway-register__field">
                <label class="gateway-register__label" for="reg-password">
                  Kata sandi
                </label>
                <div class="gateway-register__password">
                  <input
                    id="reg-password"
                    v-model="password"
                    class="gateway-register__input"
                    :type="showPassword ? 'text' : 'password'"
                    name="password"
                    autocomplete="new-password"
                    placeholder="Minimal 6 karakter"
                    :disabled="submitting"
                  />
                  <button
                    type="button"
                    class="gateway-register__toggle"
                    :aria-label="
                      showPassword ? 'Sembunyikan kata sandi' : 'Tampilkan kata sandi'
                    "
                    @click="showPassword = !showPassword"
                  >
                    {{ showPassword ? "Sembunyi" : "Lihat" }}
                  </button>
                </div>
              </div>

              <div class="gateway-register__field">
                <label class="gateway-register__label" for="reg-password-confirm">
                  Konfirmasi
                </label>
                <input
                  id="reg-password-confirm"
                  v-model="password_confirm"
                  class="gateway-register__input"
                  :type="showPassword ? 'text' : 'password'"
                  name="password_confirm"
                  autocomplete="new-password"
                  placeholder="Ulangi kata sandi"
                  :disabled="submitting"
                />
              </div>
            </div>

            <p
              v-if="localError"
              class="gateway-register__error"
              role="alert"
            >
              {{ localError }}
            </p>

            <button
              type="submit"
              class="gateway-register__submit"
              :disabled="submitting"
            >
              <span v-if="!submitting">Daftar Sekarang</span>
              <span v-else>Mendaftarkan akun…</span>
            </button>
          </form>

          <p class="gateway-register__secure">
            Sudah punya akun?
            <router-link to="/login">Masuk ke dashboard</router-link>
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "RegisterUser",
  data: () => ({
    name: "",
    email: "",
    phone: "",
    password: "",
    password_confirm: "",
    showPassword: false,
    submitting: false,
    localError: "",
    year: new Date().getFullYear(),
  }),
  mounted() {
    this.setPage({
      crud: false,
    });
    window.scrollTo(0, 0);
    document.title = "Daftar — SenderWA";
  },
  computed: {
    ...mapState(["device", "theme", "info", "http", "snackbar", "auth"]),
  },
  methods: {
    ...mapActions(["setPage", "setLoading"]),

    validate() {
      if (!this.name) return "Nama lengkap wajib diisi";
      if (!this.email) return "Email wajib diisi";
      if (!this.phone) return "Nomor WhatsApp wajib diisi";
      if (!this.password) return "Kata sandi wajib diisi";
      if (this.password.length < 6) return "Kata sandi minimal 6 karakter";
      if (this.password !== this.password_confirm) {
        return "Kata sandi dan konfirmasi tidak sama";
      }
      return "";
    },

    postRegister: async function () {
      if (this.submitting) return;

      this.localError = this.validate();
      if (this.localError) {
        this.snackbar.color = "red";
        this.snackbar.text = this.localError;
        this.snackbar.state = true;
        return;
      }

      try {
        this.submitting = true;
        this.setLoading({
          dialog: true,
          text: "Sedang mengirim data registrasi",
        });

        let {
          data: { success, message },
        } = await this.http.post("api/auth/registrasi-user", {
          name: this.name,
          email: this.email,
          phone: this.phone,
          password: this.password,
        });

        if (!success) {
          this.localError = message || "Registrasi gagal";
          this.snackbar.color = "red";
          this.snackbar.text = this.localError;
          this.snackbar.state = true;
          return;
        }

        this.snackbar.color = "green";
        this.snackbar.text = message || "Registrasi berhasil";
        this.snackbar.state = true;
        this.$router.push({
          name: "registrasi-berhasil",
        });
      } catch (error) {
        const msg =
          error?.response?.data?.errors?.[0]?.message ||
          error?.response?.data?.message ||
          "Terjadi kesalahan saat registrasi";
        this.localError = msg;
        this.snackbar.color = "red";
        this.snackbar.text = msg;
        this.snackbar.state = true;
      } finally {
        this.submitting = false;
        this.setLoading({ dialog: false, text: "" });
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Outfit:wght@500;600;700&family=Source+Sans+3:wght@400;500;600&display=swap");

.gateway-register {
  --gw-ink: #10241c;
  --gw-forest: #0d4a36;
  --gw-leaf: #1f7a57;
  --gw-mint: #8fd6b5;
  --gw-fog: #eef6f1;
  --gw-paper: #f8fbf9;
  --gw-line: #c9ddd3;
  --gw-muted: #5d7268;
  --gw-danger: #b42318;

  min-height: 100vh;
  font-family: "Source Sans 3", "Montserrat", sans-serif;
  color: var(--gw-ink);
  background: var(--gw-paper);
}

.gateway-register__stage {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(340px, 0.9fr);
  min-height: 100vh;
}

.gateway-register__brand {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: clamp(2rem, 5vw, 3.5rem);
  color: #f4fbf7;
  background:
    radial-gradient(120% 90% at 0% 0%, #1a6b4d 0%, transparent 55%),
    radial-gradient(90% 70% at 100% 100%, #0a2f24 0%, transparent 50%),
    linear-gradient(155deg, #0b3d2e 0%, #0f5c45 48%, #0a3327 100%);
}

.gateway-register__atmosphere {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.gateway-register__orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(2px);
  opacity: 0.35;
  animation: gateway-reg-float 10s ease-in-out infinite;
}

.gateway-register__orb--a {
  width: 280px;
  height: 280px;
  top: -60px;
  right: -40px;
  background: radial-gradient(circle, var(--gw-mint) 0%, transparent 70%);
}

.gateway-register__orb--b {
  width: 220px;
  height: 220px;
  bottom: 8%;
  left: -50px;
  background: radial-gradient(circle, #2aad7a 0%, transparent 70%);
  animation-delay: -3s;
}

.gateway-register__grid {
  position: absolute;
  inset: 0;
  opacity: 0.12;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.35) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.35) 1px, transparent 1px);
  background-size: 42px 42px;
  mask-image: radial-gradient(ellipse at 40% 40%, #000 30%, transparent 75%);
}

.gateway-register__signal {
  position: absolute;
  right: 4%;
  bottom: 18%;
  width: min(420px, 70%);
  color: rgba(255, 255, 255, 0.55);
}

.gateway-register__path {
  animation: gateway-reg-dash 18s linear infinite;
}

.gateway-register__node {
  fill: var(--gw-mint);
  animation: gateway-reg-pulse 2.8s ease-in-out infinite;
}

.gateway-register__node--delay {
  animation-delay: 0.6s;
}

.gateway-register__node--delay-2 {
  animation-delay: 1.2s;
}

.gateway-register__bubble {
  fill: rgba(255, 255, 255, 0.14);
  stroke: rgba(255, 255, 255, 0.28);
  animation: gateway-reg-rise 5.5s ease-in-out infinite;
}

.gateway-register__bubble--soft {
  animation-delay: -2s;
}

.gateway-register__home {
  position: relative;
  z-index: 1;
  align-self: flex-start;
  text-decoration: none;
  color: rgba(244, 251, 247, 0.8);
  font-size: 0.88rem;
  font-weight: 600;
}

.gateway-register__home:hover {
  color: #fff;
}

.gateway-register__brand-copy {
  position: relative;
  z-index: 1;
  max-width: 34rem;
  margin-top: auto;
  margin-bottom: auto;
  animation: gateway-reg-fade-up 0.7s ease-out both;
}

.gateway-register__eyebrow {
  margin: 0 0 0.85rem;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--gw-mint);
}

.gateway-register__name {
  margin: 0;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-size: clamp(2.4rem, 5vw, 4rem);
  font-weight: 700;
  line-height: 1.05;
  letter-spacing: -0.03em;
}

.gateway-register__tagline {
  margin: 1.15rem 0 0;
  max-width: 28rem;
  font-size: 1.05rem;
  line-height: 1.55;
  color: rgba(244, 251, 247, 0.82);
}

.gateway-register__points {
  list-style: none;
  margin: 1.5rem 0 0;
  padding: 0;
  display: grid;
  gap: 0.55rem;
}

.gateway-register__points li {
  position: relative;
  padding-left: 1.15rem;
  font-size: 0.92rem;
  font-weight: 600;
  color: rgba(244, 251, 247, 0.88);
}

.gateway-register__points li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.4rem;
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 2px;
  background: var(--gw-mint);
}

.gateway-register__footnote {
  position: relative;
  z-index: 1;
  margin: 0;
  font-size: 0.85rem;
  color: rgba(244, 251, 247, 0.55);
}

.gateway-register__panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: clamp(1.5rem, 4vw, 3rem);
  background:
    linear-gradient(180deg, rgba(143, 214, 181, 0.12), transparent 28%),
    var(--gw-paper);
  animation: gateway-reg-fade-in 0.55s ease-out 0.12s both;
}

.gateway-register__form-wrap {
  width: 100%;
  max-width: 440px;
}

.gateway-register__form-head {
  margin-bottom: 1.5rem;
}

.gateway-register__form-title {
  margin: 0;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-size: 1.65rem;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--gw-ink);
}

.gateway-register__form-desc {
  margin: 0.55rem 0 0;
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--gw-muted);
}

.gateway-register__form {
  display: grid;
  gap: 1rem;
}

.gateway-register__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.85rem;
}

.gateway-register__field {
  display: grid;
  gap: 0.4rem;
}

.gateway-register__label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--gw-forest);
}

.gateway-register__input {
  width: 100%;
  height: 48px;
  padding: 0 0.95rem;
  border: 1px solid var(--gw-line);
  border-radius: 10px;
  background: #fff;
  color: var(--gw-ink);
  font: inherit;
  font-size: 0.98rem;
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.gateway-register__input::placeholder {
  color: #91a59b;
}

.gateway-register__input:focus {
  border-color: var(--gw-leaf);
  box-shadow: 0 0 0 3px rgba(31, 122, 87, 0.15);
}

.gateway-register__input:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.gateway-register__password {
  position: relative;
}

.gateway-register__password .gateway-register__input {
  padding-right: 4.5rem;
}

.gateway-register__toggle {
  position: absolute;
  top: 50%;
  right: 0.55rem;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: var(--gw-leaf);
  font: inherit;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  padding: 0.35rem 0.45rem;
}

.gateway-register__toggle:hover {
  color: var(--gw-forest);
}

.gateway-register__error {
  margin: 0;
  padding: 0.7rem 0.85rem;
  border-radius: 10px;
  background: rgba(180, 35, 24, 0.08);
  color: var(--gw-danger);
  font-size: 0.88rem;
  font-weight: 600;
}

.gateway-register__submit {
  margin-top: 0.25rem;
  height: 50px;
  border: 0;
  border-radius: 10px;
  background: linear-gradient(135deg, var(--gw-leaf) 0%, var(--gw-forest) 100%);
  color: #fff;
  font-family: "Outfit", "Montserrat", sans-serif;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: transform 0.15s ease, filter 0.15s ease, opacity 0.15s ease;
}

.gateway-register__submit:hover:not(:disabled) {
  filter: brightness(1.05);
  transform: translateY(-1px);
}

.gateway-register__submit:disabled {
  opacity: 0.72;
  cursor: wait;
}

.gateway-register__secure {
  margin: 1.35rem 0 0;
  font-size: 0.9rem;
  color: var(--gw-muted);
  text-align: center;
}

.gateway-register__secure a {
  color: var(--gw-leaf);
  font-weight: 700;
  text-decoration: none;
}

.gateway-register__secure a:hover {
  color: var(--gw-forest);
  text-decoration: underline;
}

@keyframes gateway-reg-fade-up {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes gateway-reg-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes gateway-reg-float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(18px);
  }
}

@keyframes gateway-reg-dash {
  to {
    stroke-dashoffset: -280;
  }
}

@keyframes gateway-reg-pulse {
  0%,
  100% {
    opacity: 0.45;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.25);
  }
}

@keyframes gateway-reg-rise {
  0%,
  100% {
    transform: translateY(0);
    opacity: 0.85;
  }
  50% {
    transform: translateY(-8px);
    opacity: 1;
  }
}

@media (max-width: 960px) {
  .gateway-register__stage {
    grid-template-columns: 1fr;
  }

  .gateway-register__brand {
    min-height: 38vh;
    padding-bottom: 2rem;
  }

  .gateway-register__signal {
    width: min(280px, 58%);
    bottom: 8%;
    opacity: 0.7;
  }

  .gateway-register__name {
    font-size: clamp(2.2rem, 10vw, 3rem);
  }

  .gateway-register__panel {
    align-items: flex-start;
    padding-top: 2rem;
    padding-bottom: 3rem;
  }
}

@media (max-width: 560px) {
  .gateway-register__row {
    grid-template-columns: 1fr;
  }

  .gateway-register__brand {
    min-height: auto;
  }

  .gateway-register__signal {
    display: none;
  }

  .gateway-register__points {
    display: none;
  }
}
</style>
